import type { SVGProps } from 'react';

export const Flag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.57422 1.66211C1.57422 1.17886 1.96597 0.787109 2.44922 0.787109H5.15318C5.77979 0.787109 6.38573 1.01126 6.86149 1.41905L7.71596 2.15144C7.87455 2.28737 8.07653 2.36209 8.2854 2.36209H11.5492C12.0325 2.36209 12.4242 2.75384 12.4242 3.23709V10.0621C12.4242 10.5453 12.0325 10.9371 11.5492 10.9371H8.93299C8.30624 10.9371 7.70017 10.7128 7.22437 10.3049L6.37 9.57235C6.2114 9.43636 6.00938 9.36161 5.80046 9.36161H3.14922V12.3371C3.14922 12.772 2.79664 13.1246 2.36172 13.1246C1.92679 13.1246 1.57422 12.772 1.57422 12.3371V1.66211ZM8.2854 3.93709H10.8492V9.36209H8.93299C8.68229 9.36209 8.43986 9.27239 8.24954 9.10921L7.39518 8.37667C6.95109 7.99591 6.38543 7.78661 5.80046 7.78661H3.14922V2.36211H5.15318C5.40382 2.36211 5.6462 2.45177 5.8365 2.61489L6.69097 3.34728C7.13502 3.72788 7.70056 3.93709 8.2854 3.93709Z"
        fill="currentColor"
      />
    </svg>
  );
};
